module.exports = __webpack_public_path__ + "h5/img/value.affbc1d6.jpg";